<template>
  <div class="shoppe">
    <el-table :data="tableData">
      <el-table-column prop="typeName" label=""></el-table-column>
      <el-table-column label="配置项">
        <template slot-scope="scope">
          <dl class="config-item">
            <dt>商品款式分类</dt>
            <dd>
              {{ scope.row.productCategoryTypeNameList.join('、') }}
            </dd>
          </dl>
          <dl class="config-item">
            <dt>品类</dt>
            <dd>
              {{ scope.row.categoryNameList.join('、') }}
            </dd>
          </dl>
          <dl class="config-item">
            <dt>品牌</dt>
            <dd>
              {{ scope.row.brandNameList.join('、') }}
            </dd>
          </dl>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" @click="showForm(scope.row)">设置</el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog append-to-body :title="`编辑${dialogTitle}`" :visible.sync="dialogVisible" width="820px">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="商品标签" prop="productCategoryTypes">
          <el-select v-model="form.productCategoryTypes" multiple collapse-tags filterable clearable>
            <el-option v-for="item in styleList" :label="item.desc" :value="item.code" :key="item.code"></el-option>
          </el-select>
          <el-tag v-for="(tag, index) in productCategoryTypesTags" :key="tag.code" style="margin:0 10px 5px 0;" closable @close='closeTag(index, "productCategoryTypes")'>
            {{tag.desc}}
          </el-tag>
        </el-form-item>
        <el-form-item label="品类" prop="categoryIds">
          <el-cascader v-model="form.categoryIds" :options="categoryList" :props="optionProps" clearable :style="{width: '100%'}"></el-cascader>
          <!-- <el-tag v-for="(tag, index) in categoryTags" :key="tag.categoryId" style="margin:0 10px 5px 0;" closable @close='closeTag(index, "categoryIds")'>
            {{tag.label}}
          </el-tag> -->
        </el-form-item>
        <el-form-item label="品牌" prop="brandIds">
          <BrandSelect :data="brandList" v-model="form.brandIds" multiple collapse-tags filterable clearable></BrandSelect>
          <el-tag v-for="(tag, index) in brandTags" :key="tag.value" style="margin:0 10px 5px 0;" closable @close='closeTag(index, "brandIds")'>
            {{tag.label}}
          </el-tag>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStyleList,
  getRuleTypeList,
  editStageRule,
  getStageRule,
} from "./api";
import {
  getVendorBrandList,
  getCategory,
} from '../../api/mapping';
import BrandSelect from '../shared/brandSelect.vue';

export default {
  components: {
    BrandSelect,
  },
  data() {
    return {
      styleList: [],
      styleMap: {},
      typeMap: {},
      brandList: [],
      brandMap: {},
      categoryList: [],
      categoryMap: {},
      tableData: [],
      dialogVisible: false,
      form: {
        id: null,
        typeId: null,
        productCategoryTypes: [],
        categoryIds: [],
        brandIds: [],
      },
      optionProps: {
        value: 'categoryId',
        children: 'children',
        label: 'chineseName',
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      },
      dialogTitle: '',
    };
  },
  computed: {
    productCategoryTypesTags() {
      return this.styleList.filter(item => this.form.productCategoryTypes.includes(item.code));
    },
    // categoryTags() {
    //   return this.form.categoryIds.map(item => ({ categoryId: item, label: this.categoryMap[item] }));
    // },
    brandTags() {
      return this.brandList.filter(item => this.form.brandIds.includes(item.value));
    },
  },
  async created() {
    await this.init();
    this.getTableData();
  },
  methods: {
    init() {
      return Promise.all([
        getStyleList().then(res => {
          if (res.data && res.data.data) {
            this.styleList = res.data.data;
            const map = {};
            res.data.data.forEach(item => {
              map[item.code] = item.desc;
            });
            this.styleMap = map;
          }
        }),
        getRuleTypeList().then(res => {
          if (res.data && res.data.data) {
            const map = {};
            res.data.data.forEach(item => {
              map[item.typeId] = item.typeName;
            });
            this.typeMap = map;
          }
        }),
        getVendorBrandList().then(res => {
          if (res.data && res.data.data) {
            const map = {};
            this.brandList = res.data.data.map((item) => {
              map[item.brandId] = item.brandName;
              return {
                value: item.brandId,
                label: item.brandName,
              }
            });
            this.brandMap = map;
          }
        }),
        getCategory().then(res => {
          if (res.data && res.data.data) {
            this.categoryList = res.data.data;
            const map = {};
            res.data.data.forEach(item => {
              item.children.forEach(item2 => {
                item2.children.forEach(item3 => {
                  map[item3.categoryId] = `${item.chineseName}>${item2.chineseName}>${item3.chineseName}`;
                })
              })
            })
            this.categoryMap = map;
          }
        })
      ]);
    },
    getTableData() {
      getStageRule().then(res => {
        if (res.data && res.data.data) {
          this.tableData = res.data.data.map(item => {
            return {
              ...item,
              typeName: this.typeMap[item.typeId],
              categoryNameList: item.categoryIds.map(c => this.categoryMap[c]),
              brandNameList: item.brandIds.map(b => this.brandMap[b]),
              productCategoryTypeNameList: item.productCategoryTypes.map(p => this.styleMap[p]),
            }
          })
        }
      })
    },
    submit() {
      if (this.repeatSave) {
        return;
      }
      this.repeatSave = true;
      editStageRule(this.form).then(res => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.data || res.data.message);
        }
        this.repeatSave = false;
      }).catch((err) => {
        this.repeatSave = false;
      })
    },
    showForm(row) {
      this.dialogTitle = row.typeName;
      this.form.id = row.id;
      this.form.typeId = row.typeId;
      this.form.productCategoryTypes = row.productCategoryTypes || [];
      this.form.categoryIds = row.categoryIds || [];
      this.form.brandIds = row.brandIds || [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    closeTag(index, name) {
      this.form[name].splice(index, 1);
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.config-item {
  display: flex;
  dt {
    flex-shrink: 0;
    width: 60px;
    margin-right: 10px;
    text-align: right;
  }
  dd {
    color: #000;
  }
}
</style>
